module.exports = __webpack_public_path__ + "img/pin-star.350c0656.png";